import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { PackageOpen, CheckCircle, Ship, HeartHandshake } from 'lucide-react';
export function HowItWorksTease() {
  return <Section background="white" data-id="element-110">
      <div className="text-center mb-12" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-primary-deep-blue mb-4" data-id="element-112">
          How It Works
        </h2>
        <p className="text-lg font-inter text-neutral-charcoal max-w-3xl mx-auto" data-id="element-113">
          Our process ensures that medical supplies reach those who need them
          most, efficiently and transparently.
        </p>
      </div>
      <div className="grid md:grid-cols-4 gap-8" data-id="element-114">
        {[{
        icon: <PackageOpen size={32} className="text-primary-royal-blue" data-id="element-115" />,
        title: 'Source',
        description: 'We collect unused, unexpired medical supplies from U.S. hospitals and healthcare facilities.'
      }, {
        icon: <CheckCircle size={32} className="text-primary-royal-blue" data-id="element-116" />,
        title: 'Sort & Verify',
        description: 'Our team carefully sorts, inspects, and verifies all supplies to ensure quality and compliance.'
      }, {
        icon: <Ship size={32} className="text-primary-royal-blue" data-id="element-117" />,
        title: 'Ship',
        description: 'Supplies are packaged and shipped in accordance with international regulations to Egypt.'
      }, {
        icon: <HeartHandshake size={32} className="text-primary-royal-blue" data-id="element-118" />,
        title: 'Deliver & Report',
        description: 'Supplies are delivered to monastery clinics, and we provide transparent reporting on impact.'
      }].map((step, index) => <div key={index} className="bg-neutral-offwhite p-6 rounded-xl" data-id="element-119">
            <div className="mb-4" data-id="element-120">{step.icon}</div>
            <h3 className="text-xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-121">
              {step.title}
            </h3>
            <p className="font-inter text-neutral-charcoal" data-id="element-122">
              {step.description}
            </p>
          </div>)}
      </div>
      <div className="mt-12 text-center" data-id="element-123">
        <Button href="/how-it-works" variant="tertiary" data-id="element-124">
          Learn more about our process
        </Button>
      </div>
    </Section>;
}